import ServiceClient from '../ServiceClient'
import { BASE_PATH } from './consts'

export type BulaDominioRequest = Partial<{
    text: string
    codes: string[]
    offset: number
    limit: number
}>

export type BulaDominioResponse = {
    duration: number
    itens: BulaDominioIten[]
}

export type BulaDominioIten = {
    id: string
    descricao: string
}

let TASK_MAP = new Map<string, Promise<BulaDominioResponse>>()

const sendRequest = async (dominio: string, rq: BulaDominioRequest): Promise<BulaDominioResponse> => {
    const taskKey = JSON.stringify(rq)

    let runningTask = TASK_MAP.get(taskKey)
    if (runningTask) {
        return await runningTask
    }

    let doResolve: (tgtData: BulaDominioResponse) => void = () => void 0
    let doReject: (error: unknown) => void = () => void 0
    runningTask = new Promise<BulaDominioResponse>((resolve, reject) => {
        doResolve = resolve
        doReject = reject
    })

    TASK_MAP.set(taskKey, runningTask)
    try {
        const url = ServiceClient.newUrl(`${BASE_PATH}/dominios/${dominio}`)
        rq.codes && rq.codes.length > 0 && (url.searchParams.append('codes', rq.codes.join(',')))
        rq.text && (url.searchParams.append('text', rq.text))
        rq.offset > 0 && (url.searchParams.append('offset', `${rq.offset}`))
        rq.limit > 0 && (url.searchParams.append('limit', `${rq.limit}`))
        const response = await ServiceClient.authGet(url) as BulaDominioResponse
        doResolve(response)
        return response
    } catch (error) {
        doReject(error)
        throw error
    } finally {
        TASK_MAP.delete(taskKey)
    }
}

export default {

    async fabricantes(rq: BulaDominioRequest) {
        return sendRequest('fabricantes', rq)
    },

    async medicamentos(rq: BulaDominioRequest) {
        return sendRequest('medicamentos', rq)
    },

    async principiosAtivos(rq: BulaDominioRequest) {
        return sendRequest('principios-ativos', rq)
    },

    async reacoes(rq: BulaDominioRequest) {
        return sendRequest('reacoes', rq)
    }

}